// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RZszkU {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
  font-family: inherit;
  outline: none;
}

.mHZC1r {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border-bottom: 1px solid var(--border);
  flex: none;
  user-select: none;
}

.bXWvrg {
  min-width: 26px;
  height: 24px;
  padding: 0 6px;
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
}

.bXWvrg:hover:not(:disabled) {
  border-color: var(--accent);
}

.apeCdv {
  margin-left: 10px;
  font-size: 11px;
  color: var(--text-muted);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.dA_ljy {
  position: relative;
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
}

.nAXaAs {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.dWWHwH {
  position: relative;
  flex: none;
  border-bottom: 1px solid var(--border);
  background: var(--surface-2);
  overflow: hidden;
  user-select: none;
  cursor: crosshair;
}

.zpRs1e {
  position: absolute;
  inset: 0;
  display: block;
  pointer-events: none;
}

.e34fQZ {
  position: absolute;
  top: 2px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  max-width: 140px;
  padding: 0 4px;
  height: 16px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  line-height: 1;
  color: var(--text);
  background: color-mix(in srgb, var(--accent) 22%, var(--surface-2));
  border: 1px solid var(--accent);
  border-radius: 4px;
  cursor: grab;
  white-space: nowrap;
  overflow: hidden;
  z-index: 1;
}

.e34fQZ:hover {
  border-color: var(--text-muted);
}

.cMzRk3 {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--accent) 35%, transparent);
}

.bF7ooq {
  overflow: hidden;
  text-overflow: ellipsis;
  flex: none;
}

.FRq_LF {
  flex: none;
  width: 14px;
  height: 14px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--text-muted);
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  border-radius: 3px;
}

.FRq_LF:hover {
  color: var(--error, #ff6b6b);
  background: rgba(0, 0, 0, 0.2);
}

.dEQ_Mu {
  position: absolute;
  top: 1px;
  width: 140px;
  height: 18px;
  padding: 0 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--accent);
  border-radius: 4px;
  outline: none;
  z-index: 2;
}

.kH7vFa {
  flex: none;
  height: 20px;
  display: block;
  background: var(--surface-2);
}

.AEEo4L {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.bKCwdk {
  position: absolute;
  inset: 0;
  display: block;
  touch-action: none;
}

.QCATSL {
  position: absolute;
  top: 6px;
  right: 8px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  color: var(--text-muted);
  background: rgba(0, 0, 0, 0.35);
  padding: 2px 6px;
  border-radius: 4px;
  pointer-events: none;
  z-index: 2;
}

.KoRZaq,
.ADhVrC {
  position: absolute;
  background: transparent;
  z-index: 3;
}

.KoRZaq {
  left: 0;
  right: 0;
  bottom: 0;
  height: 10px;
  cursor: pointer;
}

.ADhVrC {
  top: 0;
  right: 0;
  bottom: 0;
  width: 10px;
  cursor: pointer;
}

.ABweWw,
.rtnsMU {
  position: absolute;
  background: color-mix(in srgb, var(--text-muted) 35%, transparent);
  border-radius: 5px;
  cursor: pointer;
}

.ABweWw {
  top: 1px;
  bottom: 1px;
}

.rtnsMU {
  left: 1px;
  right: 1px;
}

.ABweWw:hover,
.rtnsMU:hover {
  background: color-mix(in srgb, var(--text-muted) 55%, transparent);
}
`, "",{"version":3,"sources":["webpack://./app/src/components/TrackLanes.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,sCAAsC;EACtC,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,qEAAqE;EACrE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mEAAmE;EACnE,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,qEAAqE;EACrE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qEAAqE;EACrE,eAAe;EACf,wBAAwB;EACxB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,kEAAkE;EAClE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,kEAAkE;AACpE","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: hidden;\n  font-family: inherit;\n  outline: none;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--border);\n  flex: none;\n  user-select: none;\n}\n\n.toolbarBtn {\n  min-width: 26px;\n  height: 24px;\n  padding: 0 6px;\n  background: var(--surface);\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.toolbarBtn:hover:not(:disabled) {\n  border-color: var(--accent);\n}\n\n.readout {\n  margin-left: 10px;\n  font-size: 11px;\n  color: var(--text-muted);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n}\n\n.body {\n  position: relative;\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n}\n\n.mainCol {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.markerStripWrap {\n  position: relative;\n  flex: none;\n  border-bottom: 1px solid var(--border);\n  background: var(--surface-2);\n  overflow: hidden;\n  user-select: none;\n  cursor: crosshair;\n}\n\n.markerStrip {\n  position: absolute;\n  inset: 0;\n  display: block;\n  pointer-events: none;\n}\n\n.markerChip {\n  position: absolute;\n  top: 2px;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  max-width: 140px;\n  padding: 0 4px;\n  height: 16px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 11px;\n  line-height: 1;\n  color: var(--text);\n  background: color-mix(in srgb, var(--accent) 22%, var(--surface-2));\n  border: 1px solid var(--accent);\n  border-radius: 4px;\n  cursor: grab;\n  white-space: nowrap;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.markerChip:hover {\n  border-color: var(--text-muted);\n}\n\n.markerChipActive {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--accent) 35%, transparent);\n}\n\n.markerChipLabel {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: none;\n}\n\n.markerDelete {\n  flex: none;\n  width: 14px;\n  height: 14px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 12px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 3px;\n}\n\n.markerDelete:hover {\n  color: var(--error, #ff6b6b);\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.markerInput {\n  position: absolute;\n  top: 1px;\n  width: 140px;\n  height: 18px;\n  padding: 0 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 11px;\n  color: var(--text);\n  background: var(--surface);\n  border: 1px solid var(--accent);\n  border-radius: 4px;\n  outline: none;\n  z-index: 2;\n}\n\n.ruler {\n  flex: none;\n  height: 20px;\n  display: block;\n  background: var(--surface-2);\n}\n\n.canvasWrap {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.canvas {\n  position: absolute;\n  inset: 0;\n  display: block;\n  touch-action: none;\n}\n\n.hoverHint {\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 11px;\n  color: var(--text-muted);\n  background: rgba(0, 0, 0, 0.35);\n  padding: 2px 6px;\n  border-radius: 4px;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.hScrollbar,\n.vScrollbar {\n  position: absolute;\n  background: transparent;\n  z-index: 3;\n}\n\n.hScrollbar {\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 10px;\n  cursor: pointer;\n}\n\n.vScrollbar {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 10px;\n  cursor: pointer;\n}\n\n.hThumb,\n.vThumb {\n  position: absolute;\n  background: color-mix(in srgb, var(--text-muted) 35%, transparent);\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.hThumb {\n  top: 1px;\n  bottom: 1px;\n}\n\n.vThumb {\n  left: 1px;\n  right: 1px;\n}\n\n.hThumb:hover,\n.vThumb:hover {\n  background: color-mix(in srgb, var(--text-muted) 55%, transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RZszkU`,
	"toolbar": `mHZC1r`,
	"toolbarBtn": `bXWvrg`,
	"readout": `apeCdv`,
	"body": `dA_ljy`,
	"mainCol": `nAXaAs`,
	"markerStripWrap": `dWWHwH`,
	"markerStrip": `zpRs1e`,
	"markerChip": `e34fQZ`,
	"markerChipActive": `cMzRk3`,
	"markerChipLabel": `bF7ooq`,
	"markerDelete": `FRq_LF`,
	"markerInput": `dEQ_Mu`,
	"ruler": `kH7vFa`,
	"canvasWrap": `AEEo4L`,
	"canvas": `bKCwdk`,
	"hoverHint": `QCATSL`,
	"hScrollbar": `KoRZaq`,
	"vScrollbar": `ADhVrC`,
	"hThumb": `ABweWw`,
	"vThumb": `rtnsMU`
};
export default ___CSS_LOADER_EXPORT___;
